import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './utils/errorBoundary';
import { SessionManager } from './components/SessionManager';
import { initAnalytics } from './utils/analytics';
import './index.css';

// Initialize Google Analytics
initAnalytics('G-XXXXXXXXXX'); // Replace with your GA measurement ID

// Add preconnect hints
const preconnectUrls = [
  'https://images.unsplash.com',
  'https://www.google.com',
  'https://www.gstatic.com'
];

preconnectUrls.forEach(url => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = url;
  document.head.appendChild(link);
});

// Prevent browser auto-complete on forms
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.setAttribute('autocomplete', 'off');
    form.setAttribute('spellcheck', 'false');
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <SessionManager>
        <App />
      </SessionManager>
    </ErrorBoundary>
  </StrictMode>
);